import { FormControlLabel, InputLabel, Radio, RadioGroup } from '@mui/material';
import { Form } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import { BpCheckedIcon, BpIcon } from '../AgeRatingField/styles';
import Select from 'react-select';
import { createRef, useEffect } from 'react';

const allowCountries = [
  { name: 'Permitidos', value: 'allowedCountries' },
  { name: 'Não permitidos', value: 'deniedCountries' },
];

const getInitialSelectedCountryValues = ({
  allowedCountries,
  deniedCountries,
}) => {
  if (allowedCountries?.length) {
    return allowCountries[0].value;
  }
  if (deniedCountries?.length) {
    return allowCountries[1].value;
  }

  return null;
};

function BpRadio(props) {
  return (
    <Radio
      disableRipple
      color="default"
      checkedIcon={<BpCheckedIcon />}
      icon={<BpIcon />}
      {...props}
    />
  );
}

export const AllowedDeniedCountriesField = ({
  watch,
  control,
  setValue,
  getValues,
  viewFields,
  countriesList,
}) => {
  const allowedCountriesRef = createRef();
  const deniedCountriesRef = createRef();
  const selectedAllowCountry = watch('allow_countries');
  const allowedCountries = getValues('allowedCountries');
  const deniedCountries = getValues('deniedCountries');

  useEffect(() => {
    setValue(
      'allow_countries',
      getInitialSelectedCountryValues({
        allowedCountries,
        deniedCountries,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Form.Group className="mb-3" controlId="formName">
        <InputLabel className="form-label" htmlFor="name">
          Lista de país
        </InputLabel>

        <Controller
          name="allow_countries"
          control={control}
          render={({ field }) => {
            const initialSelectValue = getInitialSelectedCountryValues({
              allowedCountries,
              deniedCountries,
            });

            return (
              <RadioGroup
                aria-labelledby="radio-buttons-group-label"
                id="radio-button-allow-denied-countries"
                {...field}
                value={field.value || initialSelectValue}>
                {allowCountries.map(country => (
                  <FormControlLabel
                    key={country.name}
                    value={country.value}
                    style={{ width: '45%' }}
                    control={<BpRadio />}
                    label={country.name}
                    disabled={viewFields}
                  />
                ))}
              </RadioGroup>
            );
          }}
        />
      </Form.Group>
      <Form.Group className="mb-3" controlId="formName">
        <InputLabel
          className={`form-label ${
            selectedAllowCountry === 'deniedCountries' ? '' : 'hidden'
          }`}
          htmlFor="name">
          {'Países <não permitidos>'}
        </InputLabel>

        <InputLabel
          className={`form-label ${
            selectedAllowCountry === 'allowedCountries' ? '' : 'hidden'
          }`}
          htmlFor="name">
          {'Países <permitidos>'}
        </InputLabel>
        {selectedAllowCountry === 'allowedCountries' && (
          <Controller
            name="allowedCountries"
            control={control}
            render={({ field: { value, onBlur } }) => (
              <Select
                id="video-select-allow-countries"
                isMulti
                isDisabled={!selectedAllowCountry || viewFields}
                placeholder={'Selecione o(s) país(es)'}
                options={countriesList}
                value={value?.map(country => ({
                  acronym: country.name || country.acronym,
                  id: country.countryId || country.id,
                  label: country.name || country.label,
                  value: country.countryId,
                  countryId: country.countryId || country.id,
                }))}
                selectRef={allowedCountriesRef}
                onChange={values => {
                  setValue('allowedCountries', values);
                  setValue('deniedCountries', []);
                }}
                onBlur={onBlur}
              />
            )}
          />
        )}
        {selectedAllowCountry === 'deniedCountries' && (
          <Controller
            name="deniedCountries"
            control={control}
            render={({ field: { value, onBlur } }) => (
              <Select
                id="video-select-denied-countries"
                isMulti
                isDisabled={!selectedAllowCountry || viewFields}
                placeholder={'Selecione o(s) país(es)'}
                options={countriesList}
                value={value?.map(country => ({
                  acronym: country.name || country.acronym,
                  id: country.countryId || country.id,
                  label: country.name || country.label,
                  value: country.countryId,
                  countryId: country.countryId || country.id,
                }))}
                selectRef={deniedCountriesRef}
                onChange={values => {
                  setValue('deniedCountries', values);
                  setValue('allowedCountries', []);
                }}
                onBlur={onBlur}
              />
            )}
          />
        )}
      </Form.Group>
    </>
  );
};
